<template>
    <div :class="'ext-input form-group '+col+' '+form_class">
      <select
      :class="'form-select '+ input_class"
      aria-label=""
      :id="input_id"
      :value="modelValue"
      @input="$event => $emit('update:modelValue', $event.target.value)"
      >
      <option value="" >Seçiniz</option>
      <option v-for="(item, index) in optarr" :value="item[opt_value]" :key="index">{{ item[opt_name] }}</option>
      </select>
    <label :for="input_id">{{ label }}</label>
    </div>




</template>

<script>
export default {
  name: 'InputSelect',
  props: {
    optarr: Array,
    opt_value: String,
    opt_name: String,
    form_class: String,
    input_id: String,
    input_class: String,
    modelValue: String,
    label: String,
    col: String,
    placeholder: String,
  },
  methods: {
    calcName () {
      this.$emit('changeUsername')
    }
  }
}
</script>

<style lang="css">

.ext-input {
  position: relative;
  z-index: auto;
}
.ext-input label{
position: absolute;
z-index: +1;
top: -12px;
left: 20px;
background-color:var(--app-background) ;
padding: 2px 6px;
font-size: 0.78rem;
color: var(--ext-label-color) !important;
}

.ext-input select{
min-height: 48px !important;
background-color: var(--app-background) !important;
color:var(--tema-renk01) !important;
font-weight: 400 !important;
font-size: 1.2rem !important;

}

.ext-float input{
min-height: 60px !important;
background-color: white !important;
color:rgb(46, 51, 63) !important;
font-weight: 700 !important;
}
.ext-float input,.ext-float label{
    font-family: "acumin-pro", sans-serif;
font-weight: 400;
font-style: normal;
}
.ext-float input{
font-size:1.2rem !important;
}
.ext-float label{
    font-family: "acumin-pro", sans-serif;
font-weight: 400;
font-style: normal;
padding-left: 20px !important;
color: rgb(223, 68, 12);
}

.ext-float input:focus + label, .ext-float input:not(:focus){
    color: rgb(223, 68, 12);
    background: white !important;
    opacity: 1 !important;
    top:-2px !important;
    left: 10px;
    padding: 0px !important;
    height: 20px !important;
    width: fit-content !important;
}
</style>
